import React, { Component } from 'react';
import { Router } from '@reach/router';
import Create from './create';
import Dash from './dashboard';
import Archive from './archive';
import Profile from './profile';
import NotFound from '../public/404';
import Upgrade from '../public/pro';

import Tos from '../public/tos';
class AppPrivate extends Component {
  render() {
    return (
      <>
        <Router>
          <NotFound default />
          <Dash path="/" />
          <Archive path="archive" />
          <Create path="new" />
          <Profile path="profile" />
          <Upgrade path="upgrade" />
          <Tos path="terms-of-service" />
        </Router>
      </>
    );
  }
}

export default AppPrivate;
